import React, { useState } from "react";
import {
  Pagination,
  SearchFilter,
  TitleWithFilters
} from "MODULES/shared/components/Pagination";
import { Authorized, Search } from "MODULES/shared/components";
import { SALES } from "MODULES/users/constants";
import Table from "./Table";
import { reservedForSaleInventory } from "../pagination";
import Create from "./ConvertDummyForm/Create";

export default function SaleOrderSearch() {
  const [modalOpen, setModalOpen] = useState(false);
  return (
    <Authorized roles={[SALES]} allowManagers>
      <Search search={reservedForSaleInventory} syncWithUrl>
        {searchProps => (
          <div>
            <div className="form-group form-group-searchbar has-feedback has-feedback-left">
              <i className="text-muted fa fa-search form-control-feedback form-control-feedback-left" />
              <div className="input-group">
                <SearchFilter
                  {...searchProps}
                  placeholder="Search by typing a part number or serial number..."
                />
                <div className="input-group-btn">
                  <button
                    onClick={() => setModalOpen(true)}
                    className="btn btn-primary pull-right"
                    type="button"
                  >
                    <i className={`fa fa-fw fa-plus`} />
                    Create Reserve SO
                  </button>
                </div>
              </div>
            </div>
            <TitleWithFilters {...searchProps} title="Reserved For Sale" />
            <Create open={modalOpen} close={() => setModalOpen(false)} />
            <Table {...searchProps} />
            <Pagination {...searchProps} />
          </div>
        )}
      </Search>
    </Authorized>
  );
}



// WEBPACK FOOTER //
// ./app/modules/SalesOrders/ReserveForSale/Search.jsx